import { render, staticRenderFns } from "./CustomerRegistration.vue?vue&type=template&id=b5d8dac4&scoped=true&"
import script from "./CustomerRegistration.vue?vue&type=script&lang=js&"
export * from "./CustomerRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRegistration.vue?vue&type=style&index=0&id=b5d8dac4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d8dac4",
  null
  
)

export default component.exports